import React from 'react';
import { connect } from 'react-redux';
import Lightbox from 'react-images';

const mapDispatchToProps = dispatch => ({
    onGalleryClose: () => dispatch({type: 'GALLERY_CLOSE'}),
    onPreviousClick: () => dispatch({type: 'PREVIOUS_CLICK'}),
    onNextClick: () => dispatch({type: 'NEXT_CLICK'}),
    onThumbnailClick: payload => dispatch({type: 'THUMBNAIL_CLICK', payload})

});

const mapStateToProps = state => ({
  ...state.gallery
});

const theme = {
	// container
	container: { background: 'rgba(255, 255, 255, 0.9)' },

	// arrows
	arrow: {
		backgroundColor: 'rgba(255, 255, 255, 0.8)',
		fill: '#222',
		opacity: 0.6,
		transition: 'opacity 200ms',

		':hover': {
			opacity: 1,
		},
	},
	arrow__size__medium: {
		borderRadius: 40,
		height: 40,
		marginTop: -20,

		'@media (min-width: 768px)': {
			height: 70,
			padding: 15,
		},
	},
	arrow__direction__left: { marginLeft: 10 },
	arrow__direction__right: { marginRight: 10 },

	// header
	close: {
		fill: '#D40000',
		opacity: 0.6,
		transition: 'all 200ms',

		':hover': {
			opacity: 1,
		},
	},

	// footer
	footer: {
		color: 'black',
	},
	footerCount: {
		color: 'rgba(0, 0, 0, 0.6)',
	},

	// thumbnails
	thumbnail: {
	},
	thumbnail__active: {
		boxShadow: '0 0 0 2px #00D8FF',
	},
};

class Gallery extends React.Component {

  onGalleryClose() {
    this.props.onGalleryClose();
  }

  gotoPrevious() {
		this.props.onPreviousClick();
	}

	gotoNext() {
		this.props.onNextClick();
	}

	gotoImage(index) {
    this.props.onThumbnailClick(index);
	}

  render() {
    if(!this.props.images) return null;

    return (
      <Lightbox
        images={this.props.images}
        currentImage={this.props.currentImage}
        isOpen={this.props.isGalleryOpen}
        showThumbnails={true}
        backdropClosesModal={true}
        onClose={this.onGalleryClose.bind(this)}
        preloadNextImage={false}
        theme={theme}
        onClickNext={this.gotoNext.bind(this)}
        onClickPrev={this.gotoPrevious.bind(this)}
        onClickThumbnail={this.gotoImage.bind(this)}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);



// WEBPACK FOOTER //
// ./src/components/Gallery.js